import React, {forwardRef} from 'react'
import {updateRef} from '@containers/element-utils'
import {TwIcon} from '../containers'
import {TwLinkButtonNew, TwText} from './containers'
import {LinkButtonNewProps} from './types'

export const LinkButtonNew = forwardRef<HTMLElement, LinkButtonNewProps>(
  (
    {
      icon,
      iconAfter,
      iconViewBox = '0 0 24 24',
      title,
      onClick,
      onMouseDown,
      color = 'primary',
      size = 'md',
      disabled,
      forcedState,
      className,
      iconAfterClassName,
      children
    },
    forwardedRef
  ) => (
    <TwLinkButtonNew
      ref={el => updateRef(el, forwardedRef)}
      data-test="link-button-new"
      role="button"
      $color={color}
      $size={size}
      $disabled={disabled}
      $forcedState={forcedState}
      onClick={!disabled ? onClick : undefined}
      onMouseDown={!disabled ? onMouseDown : undefined}
      className={className}
    >
      {icon && <TwIcon icon={icon} viewBox={iconViewBox} />}
      {children ?? (title && <TwText>{title}</TwText>)}
      {iconAfter && (
        <TwIcon
          icon={iconAfter}
          className={iconAfterClassName}
          viewBox={iconViewBox}
        />
      )}
    </TwLinkButtonNew>
  )
)
